import React from 'react';
export function StickyMobileCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-zinc-950/90 backdrop-blur-lg border-t border-zinc-800 z-50" data-id="element-216">
      <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full py-3.5 px-4 text-sm font-bold text-white bg-blue-600 rounded-xl shadow-[0_0_15px_rgba(37,99,235,0.3)] active:scale-95 transition-transform" data-id="element-217">
        Acceder al curso — $24.900 ARS
      </a>
    </div>;
}